import "bootstrap/dist/css/bootstrap.css";
import "@fontsource-variable/inter";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";

import "./styles/MainTheme.scss";
import ThemeManager from "./ThemeManager";
import store from "./redux/store";

import { OpenAPI } from "./api/core/OpenAPI";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

if (process.env.NODE_ENV === "development") {
  OpenAPI.BASE = "http://localhost:7011";
}

root.render(
  <Provider store={store}>
    <BrowserRouter basename={baseUrl}>
      <ThemeManager>
        <App />
      </ThemeManager>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
